<template>
  <div class="scouting-div">
    <button
      v-if="images.length"
      class="scouting-image-trigger"
      type="button"
      :aria-label="$t('scouting.click_to_view_images')"
      :title="$t('scouting.click_to_view_images')"
      @click="openSlider"
    >
      <i class="fa fa-image" aria-hidden="true"></i>
      <span>{{ $t('scouting.view_images', { count: images.length }) }}</span>
    </button>

    <photo-slider-dialog
      v-if="sliderVisible"
      :visible="sliderVisible"
      :images="images"
      :initial-index="selectedImageIndex"
      :title="sliderTitle"
      @close="sliderVisible = false"
    />
  </div>
</template>
<script>
import PhotoSliderDialog from "@/components/Common/PhotoSliderDialog.vue";

export default {
  name: "ScoutingImage",
  props: ["data"],
  data() {
    return {
      selectedImageIndex: 0,
      sliderVisible: false,
    };
  },
  components: {
    PhotoSliderDialog,
  },
  computed: {
    images() {
      return Array.isArray(this.data?.images) ? this.data.images : [];
    },
    sliderTitle() {
      const diseaseNames = (this.data.diseases || [])
        .map((disease) => disease.name)
        .filter(Boolean)
        .join(", ");

      return [this.data.reported_date, this.data.parcel_name, diseaseNames].filter(Boolean).join(" / ");
    },
  },
  methods: {
    openSlider() {
      this.selectedImageIndex = 0;
      this.sliderVisible = true;
    },
  },
};
</script>

<style scoped>
.scouting-div {
  display: flex;
  justify-content: center;
}
.scouting-image-trigger {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 34px;
  padding: 2px 4px;
  border: 0;
  background: transparent;
  color: #39734a;
  cursor: pointer;
  font-size: 18px;
}
.scouting-image-trigger span {
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
}
.scouting-image-trigger:hover {
  color: #245332;
}
.scouting-image-trigger:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
</style>
